var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_298_941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.963624 18.9818C0.960545 8.51717 9.23905 -0.00474032 19.4036 1.9783e-06C29.6466 0.00474427 37.9236 8.49187 37.9251 18.9882C37.9251 29.5271 29.6528 37.9652 19.3251 37.9605C9.21904 37.9542 0.966703 29.4244 0.963624 18.9818ZM6.23064 28.1645C9.94112 24.4386 14.3367 22.4753 19.479 22.4801C24.6152 22.4848 29 24.4655 32.6643 28.1471C36.618 22.5812 36.7689 13.3179 30.5858 7.17193C24.5105 1.13341 14.9818 0.969011 8.7279 6.77516C2.39547 12.6556 2.0121 22.0485 6.23064 28.1645Z",
    fill: "#F18434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4697 20.2465C15.3851 20.2465 12.0642 16.851 12.0596 12.6699C12.055 8.47927 15.359 5.06956 19.4359 5.06166C23.5436 5.05376 26.8599 8.47927 26.8445 12.7157C26.8306 16.8494 23.5035 20.2465 19.4682 20.2449L19.4697 20.2465Z",
    fill: "#F18434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_298_941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.9615,
    height: 37.9605,
    fill: "white",
    transform: "translate(0.963623)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccount);
export default __webpack_public_path__ + "static/media/my_account.52242fa17dcbb593a5848638c6b55c5c.svg";
export { ForwardRef as ReactComponent };